import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import LoginPage from "../LoginPage/LoginPage";
import Header from "../Header";
import SideBar from "../Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import BookShelf from "../../pages/BookShelf/BookShelf";
import back from "../../assets/back.svg";
import "./BookDetailPage.css";
import prevChap from '../../assets/arrow-90deg-left.svg';
import nextChap from '../../assets/arrow-90deg-right.svg';
import prevSec from '../../assets/prevSec.svg'
import nextSec from '../../assets/nextSec.svg'
import play from '../../assets/play.svg';
import pause from '../../assets/pause.svg';
import { REACT_APP_SHRAVAN_BASE_URL } from "../../utils/constants";

const userPhoneNumber = localStorage.getItem("userPhoneNumber");

function BookDetailPage() {

  const { mainCategory, category, bookName } = useParams();
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [book, setBook] = useState(null);
  const [currentStream, setCurrentStream] = useState(null);
  const [loadingTopics, setLoadingTopics] = useState(false);
  const [topics, setTopics] = useState({});
  const [isPaused, setIsPaused] = useState(true);
  const [resumeVisible,setResumeVisible] = useState(true);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  const [hasEnded, setHasEnded] = useState(false);
  const [shelf, setShelf] = useState(false);
  const [chapIndex, setChapIndex] = useState();

  const handleEnded = async () => {
    if (!hasEnded) {
      setHasEnded(true);
      if (audioRef != null && audioRef.current) {
        await handlePlayNext();
      }
    }
  };

  useEffect(() => {
    // const user = localStorage.getItem('user');
    // if (user) {
    setIsLoggedIn(true);
    // updateLoginTimestamp(user);
    if(category !== "Nclude Books") {
      fetchBook().then((audiobook) => {
        fetchTopics(audiobook);
      });
    } else {
      
    }
    
    // } else {
    //     setIsLoggedIn(false);
    // }
  }, []);
  useEffect(() => {
    console.log(chapIndex);
  }, [chapIndex])

  const updateLoginTimestamp = async (phone) => {
    try {
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/user/updateLoginTimestamp/${phone}`
      );
      return response.data;
    } catch (error) {
      console.error("Error updating:", error);
      return null;
    }
  };

  const fetchBook = async () => {
    setMessage("");
    setError("");
    setLoadingTopics(true);
    try {
      const response = await axios.get(`${REACT_APP_SHRAVAN_BASE_URL}/book/${bookName}`);
      setBook(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching topics:", error);
      return null;
    }
  };

  const fetchTopics = async (audiobook) => {
    setMessage("");
    setError("");
    setLoadingTopics(true);
    const bookName = audiobook.bookAwsName;
    if (!topics[bookName]) {
      // Check if topics for this book have already been fetched
      try {
        const response = await axios.get(
          `${REACT_APP_SHRAVAN_BASE_URL}/getBookTopics/${bookName}`
        );
        setTopics((prev) => ({ ...prev, [bookName]: response.data })); // Store topics
        console.log(topics);
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    }
  };

  const handlePlay = async () => {
    setMessage("");
    setError("");
    setChapIndex(0);
    try {
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/play/${book.bookAwsName}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      setError(err.message);
    }
  };

  const handlePlayNext = async () => {
    setMessage("");
    setError("");
    setChapIndex(chapIndex + 1);
    try {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPaused(true);
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/section/next/${book.bookAwsName}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };

  const handlePlayPrev = async () => {
    setMessage("");
    setError("");
    try {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPaused(true);
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/section/prev/${book.bookAwsName}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };

  const handlePlayNextChapt = async (topicIndex = 0) => {
    setMessage("");
    setError("");
    setChapIndex(topicIndex);
    console.log(`${REACT_APP_SHRAVAN_BASE_URL}/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`);
    try {
      setIsPaused(true);
      if (audioRef.current) {
        audioRef.current.pause();
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;
      if (response.headers["clip-begin"]) {
        const startTime = response.headers["clip-begin"]
          .split("=")[1]
          .replace("s", "");
        audioRef.current.currentTime = startTime;
      }
      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };

  const handlePlayPrevChapt = async (topicIndex = 0) => {
    setMessage("");
    setError("");
    setChapIndex(topicIndex);
    console.log(`${REACT_APP_SHRAVAN_BASE_URL}/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`);
    try {
      setIsPaused(true);
      if (audioRef.current) {
        audioRef.current.pause();
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;
      if (response.headers["clip-begin"]) {
        const startTime = response.headers["clip-begin"]
          .split("=")[1]
          .replace("s", "");
        audioRef.current.currentTime = startTime;
      }

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };
  const handlePause = () => {
    setMessage("");
    setError("");
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPaused(true);
    }
  };

  const handlePlayChapter = async (topicIndex) => {
    setMessage("");
    setError("");
    setChapIndex(topicIndex)
    try {
      setIsPaused(true);
      if (audioRef.current) {
        audioRef.current.pause();
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/section/play/${book.bookAwsName}/${topicIndex}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;
      if (response.headers["clip-begin"]) {
        const startTime = response.headers["clip-begin"]
          .split("=")[1]
          .replace("s", "");
        audioRef.current.currentTime = startTime;
      }

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };

  const handleResumePlay = async (topicIndex) => {
    setResumeVisible(false);
    setMessage("");
    setError("");
    try {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPaused(true);
      }
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/getProgress/${book.bookAwsName}/${userPhoneNumber}`,
        {
          responseType: "blob",
        }
      );
      const audioUrl = URL.createObjectURL(response.data);
      audioRef.current.src = audioUrl;
      if (response.headers["clip-begin"]) {
        const startTime = response.headers["clip-begin"]
          .split("=")[1]
          .replace("s", "");
        audioRef.current.currentTime = startTime;
      }

      // Wait for the audio to be ready before playing
      audioRef.current.oncanplaythrough = () => {
        setIsPaused(false);
        setHasEnded(false);
        audioRef.current.play().catch((error) => {
          console.error("Error attempting to play:", error);
        });
      };

      setCurrentStream(audioUrl);
    } catch (err) {
      if (err.status == 404) {
        //no more pages
        setMessage("No more sections or pages to play");
        return;
      }
      setError(err.message);
    }
  };

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="">
      {!isMobile && <Header activePage="lib" curr={0} setShelf={setShelf} />}
      <div className="page-container">
        <SideBar activePage="Library" />
        {isMobile && <header className="mobile-header">
      <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <div tabIndex={0} onClick={()=> setShelf(false)} className={shelf?"":"active-accessibility-header"}>{'Browse All Books'}</div>
        <div tabIndex={0} onClick={()=> setShelf(true)} className={shelf?"active-accessibility-header":""}>Book Shelf</div>
      </div>  
    </header>}
        <div className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile?"2rem":""}}>
          {shelf && <BookShelf />}

          {!shelf && (
            <div className="container">
              <section className="header-wrap d-flex justify-content-start align-items-center">
                <div>
                  {/* <button
                  onClick={() => {
                    handlePause();
                    navigate(-1);
                  }}
                  className="btn btn-secondary"
                >
                  Go Back
                </button> */}
                  <div
                    style={{
                      color: "#5030E5",
                      cursor: "pointer",
                      fontSize: isMobile?"2.5rem":"1rem",
                      gap: "0.2rem",
                      marginBottom:isMobile?"2rem":"1rem"
                    }}
                    role="button"
                    className="d-flex single-article back-button"
                    onClick={() => {
                      handlePause();
                      navigate(-1);
                    }}
                  >
                    <img src={back} alt="" style={{ width: isMobile?"3rem":"2rem" }}/>
                    Back
                  </div>
                  {/* <h1 className="logo my-auto mt-5">
                  <span className="assistive-text">
                    Shravan Audiobooks Library
                  </span>
                </h1> */}
                </div>
              </section>

              <div className="main-content">
                {book && (
                  <div className="page book-page">
                    <div className="content-wrap clearfix">
                      <h1
                        className="book-title mt-5"
                        aria-label={"Book: " + book.bookName}
                      >
                        {book.bookName}
                      </h1>
                      <h2 className="book-page-author me-3 fw-semibold mt-2">
                        Author: {book.author}
                      </h2>
                      <h2 className="book-page-category me-3 fw-semibold">
                        Category: {book.category}
                      </h2>
                      <h2 className="book-page-language fw-semibold">
                        Language: {book.language}
                      </h2>
                      <div style={{ marginTop: "5rem" }}>
                        <p className="p-tag">Notice</p>
                        <p className="w-[80%]">
                          This accessible media has been made available to
                          people with bona fide disabilities that affect
                          reading. This notice tells you about restrictions on
                          the use of this accessible media, which could be a
                          book, a periodical, or other content.
                        </p>
                      </div>

                      <div style={{ marginTop: "3rem" }}>
                        <p className="p-tag">Copyright Notice</p>
                        <p className="w-[80%]">
                          This notice is not part of the copyrighted work, which
                          begins below after the phrase "Begin Content".
                          Bookshare distributes this accessible media under
                          restrictions set forth either in copyright law or in
                          an agreement with the copyright owner. If you are not
                          a person with a print disability, or an agency serving
                          people with print disabilities, you should not use
                          this accessible media and should destroy this content.
                          You are not allowed to redistribute content derived
                          from this accessible media to anybody else, with one
                          exception: we allow hardcopy Braille books prepared
                          from Accessible Media to be provided to other blind
                          people. <br/><br/>Access to accessible media through Bookshare
                          is a valuable right and privilege. Protect this access
                          for the print disabled community by complying with
                          these restrictions!
                        </p>
                      </div>
                    </div>
                    <audio
                      aria-hidden="true"
                      ref={audioRef}
                      autoPlay={true}
                      onEnded={handleEnded}
                    >
                      <source src={currentStream} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                    <div className="d-flex flex-wrap mt-5 audio-options-container" >
                    <Button
                        className="mx-2 audio-control-btn"
                        variant="primary"
                        onClick={() => handlePlayNextChapt((chapIndex ?? 0) - 1)}
                        aria-label={
                          "Play previous chapter of  " + book.bookName
                        }
                      >
                        <img src={prevChap} alt="Play Previous chapter"/>
                      </Button>
                      {resumeVisible && <Button
                        className="mx-2 audio-control-btn"
                        variant="primary"
                        onClick={handleResumePlay}
                        aria-label={"Resume playing " + book.bookName}
                      >
                        Resume
                      </Button>}
                      <Button
                        className="mx-2 audio-control-btn"
                        variant="primary"
                        onClick={isPaused ? handlePlay : handlePause}
                        aria-label={
                          (isPaused ? "Play " : "Pause ") + book.bookName
                        }
                      >
                        <img src={isPaused ? play  : pause } alt=""/>
                      </Button>
                      <Button
                        className="mx-2 audio-control-btn"
                        variant="primary"
                        onClick={() => handlePlayNextChapt((chapIndex ?? 0) + 1)}
                        aria-label={"Play next chapter of " + book.bookName}
                      >
                        <img src={nextChap} alt="Play Previous chapter"/>
                      </Button>
                    </div>
                    <table className="chapter-list mt-4 custom-table" style={{ marginBottom: '4rem' }}>
                      <thead>
                        <tr>
                          <th>Action</th>
                          <th>Type</th>
                          <th>Title</th>
                        </tr>
                      </thead>
                      <tbody>
                        {book &&
                          topics[book?.bookAwsName] &&
                          topics[book?.bookAwsName].map((chapter) => (
                            <tr key={chapter.index}>
                              <td>
                                <Button
                                  className="mx-3"
                                  variant="primary"
                                  aria-label={`Play ${chapter.type} ${chapter.content}`}
                                  onClick={() => handlePlayChapter(chapter.index)}
                                >
                                  Play
                                </Button>
                              </td>
                              <td>{chapter.type.toUpperCase()}</td>
                              <td className="chapter-name">{chapter.content}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="" role="alert">
                      {message && <p className="text-success">{message}</p>}
                      {error && <p style={{ color: "red" }}>Error: {error}</p>}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="floating-buttons">
          <button
            className="floating-btn left"
            onClick={handlePlayPrev}
          >
            <img src={prevSec} alt="Play Previous Chapter" />
          </button>
          <button
            className="floating-btn right"
            onClick={handlePlayNext}
          >
            <img src={nextSec} alt="Play Next Chapter" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default BookDetailPage;
